// libraries
import { useState } from 'react';
import { Input, Modal, notification } from 'antd';
import { DeleteFilled } from '@ant-design/icons';

import { txt } from '../../locales/i18n';

export type DeleteModalProps = {
	useVisible: [boolean, (state: boolean) => void];
	onConfirm: () => void | Promise<void>;
	children?: React.ReactNode;
	onDismiss?: () => void | Promise<void>;
};

export function DeleteModal(props: DeleteModalProps): JSX.Element {
	const [visible, setVisible] = props.useVisible;
	const [loading, setLoading] = useState<boolean>(false);
	const [confirmText, setConfirmText] = useState<string>('');

	async function handleConfirm(): Promise<void> {
		setLoading(true);

		try {
			await props.onConfirm();
			notification.success({ message: txt('notification.deletion successful') });
			setVisible(false);
		} catch (error) {
			notification.error({ message: txt('notification.deletion failed') });
		}

		setLoading(false);
	}

	async function handleCancel(): Promise<void> {
		setVisible(false);
		setConfirmText('');
		await props.onDismiss?.();
	}

	return (
		<Modal
			okText={[<DeleteFilled key={1} />, <span key={2}>{txt('global.delete')}</span>]}
			cancelText={txt('global.cancel')}
			maskClosable
			visible={visible}
			onCancel={handleCancel}
			okButtonProps={{ disabled: confirmText.toLowerCase() !== txt('global.delete').toLowerCase(), danger: true }}
			onOk={handleConfirm}
			confirmLoading={loading}
		>
			<p> {txt('notification.confirm delete text')}</p>
			<Input value={confirmText} onChange={(event) => setConfirmText(event.target.value)} />

			{props.children ?? null}
		</Modal>
	);
}
